@if (attributesForm) {
  <form
    [formGroup]="attributesForm"
    [ngClass]="{ 'attributes-form': true, 'team-attributes-form': onTeamForm }"
  >
    @for (
      attribute of formPage.editableAttributes;
      track attribute.attributeDefinitionId
    ) {
      @if (
        attribute.isVisible &&
        !attribute.isHidden &&
        (!attribute.isReadOnly || attribute.hasValue())
      ) {
        <div
          class="attribute-row"
          [ngClass]="attribute.isReadOnly ? 'readonly' : ''"
        >
          @if (!attribute.isReadOnly) {
            @if (!this.hideLabel) {
              <app-field-label
                [props]="attribute"
                [useAttributeDescription]="useAttributeDescription"
              >
                <ng-content></ng-content>
              </app-field-label>
            }
            @if (attribute.supportsOtherValue()) {
              @if (attribute.type === dropDownAttributeUiType) {
                <div
                  attr.aria-labelledby="{{ attribute.attributeDefinitionId }}"
                >
                  <mat-form-field
                    appearance="outline"
                    floatLabel="always"
                    [fxFlex]="fxFlexWidth"
                    class="dropdown-field"
                  >
                    <mat-select
                      placeholder="{{
                        attribute.required ? 'Required' : 'None selected'
                      }}"
                      [formControlName]="attribute.attributeDefinitionId"
                      (selectionChange)="
                        assignValueToAttribute(attribute);
                        onDropdownChange($event, attribute);
                        onFieldChanged(attribute.attributeDefinitionId)
                      "
                      [compareWith]="
                        dropDownAttributeDefinitionValueListItemComparer
                      "
                      [attr.aria-describedby]="attribute.attributeDefinitionId"
                    >
                      <mat-option>None selected</mat-option>
                      @for (
                        valueListItem of getAttributeValueList(attribute);
                        track valueListItem
                      ) {
                        <mat-option
                          class="attribute-editor-style"
                          [value]="valueListItem"
                        >
                          {{ valueListItem.itemValue }}
                        </mat-option>
                      }
                    </mat-select>
                    @if (
                      attributesForm
                        .get(attribute.attributeDefinitionId)
                        .hasError('notEmpty')
                    ) {
                      <mat-error>
                        {{
                          attributesForm
                            .get(attribute.attributeDefinitionId)
                            .getError('notEmpty')
                        }}
                      </mat-error>
                    }
                  </mat-form-field>
                </div>
              } @else if (attribute.type === checkboxAttributeUiType) {
                <div
                  class="checkbox-container"
                  attr.aria-labelledby="{{ attribute.attributeDefinitionId }}"
                  [formArrayName]="attribute.attributeDefinitionId"
                  [ngClass]="
                    attributesForm.get(attribute.attributeDefinitionId)
                      .touched &&
                    (attributesForm
                      .get(attribute.attributeDefinitionId)
                      .hasError('notEmpty') ||
                      attributesForm
                        .get(attribute.attributeDefinitionId)
                        .hasError('maxSelections'))
                      ? 'checkbox-error'
                      : 'checkbox-text'
                  "
                  role="group"
                  attr.aria-labelledby="{{ attribute.attributeDefinitionId }}"
                  (change)="onFieldChanged(attribute.attributeDefinitionId)"
                >
                  <div class="checkbox-required-text">
                    @if (attribute.required) {
                      <div>Required</div>
                    }
                  </div>
                  @for (
                    valueListItem of getAttributeValueList(attribute);
                    track valueListItem
                  ) {
                    <div class="checkbox-item">
                      <mat-checkbox
                        class="checkbox-text"
                        color="primary"
                        (change)="
                          updateCheckboxAttributeDefinition(
                            attribute,
                            valueListItem,
                            $event
                          );
                          onCheckboxChange($event, valueListItem, attribute);
                          onFieldChanged(attribute.attributeDefinitionId)
                        "
                        [checked]="getCheckboxStatus(attribute, valueListItem)"
                        [disabled]="
                          attribute.isReadOnly ||
                          isCheckboxDisabled(attribute, valueListItem)
                        "
                      >
                        {{ valueListItem.itemValue }}
                      </mat-checkbox>
                      @if (useAttributeDescription) {
                        <div
                          [class.less]="valueListItem['show']"
                          class="checkbox-item-container"
                          [innerHtml]="
                            valueListItem?.itemDescription | safeHtml
                          "
                        ></div>
                      }
                      @if (
                        useAttributeDescription &&
                        isDisplayed(valueListItem.itemDescription)
                      ) {
                        <button
                          mat-button
                          color="primary"
                          (click)="
                            valueListItem['show'] = !valueListItem['show']
                          "
                          class="checkbox-more-less"
                        >
                          {{
                            valueListItem['show'] ? 'Show Less' : 'Show More'
                          }}
                          <mat-icon>{{
                            valueListItem['show']
                              ? 'expand_less'
                              : 'expand_more'
                          }}</mat-icon>
                        </button>
                      }
                    </div>
                  }
                  @if (
                    attributesForm
                      .get(attribute.attributeDefinitionId)
                      .hasError('maxSelections')
                  ) {
                    <mat-error>{{
                      attributesForm
                        .get(attribute.attributeDefinitionId)
                        .getError('maxSelections')
                    }}</mat-error>
                  }
                </div>
              } @else if (attribute.type === multiSelectAttributeUiType) {
                <multiselect
                  [isTouched]="isAttributeTouched(attribute)"
                  [items]="getMultiselectValueList(attribute)"
                  [filterMode]="false"
                  (selectionChanged)="
                    multiSelectChanged(attribute, $event);
                    onMultiselectChange($event, attribute)
                  "
                  (change)="onFieldChanged(attribute.attributeDefinitionId)"
                  [required]="attribute.required"
                  [errorMessage]="attribute.name + ' is required'"
                  [placeholder]="'Please select...'"
                  [ariaLabelledby]="attribute.attributeDefinitionId"
                ></multiselect>
              } @else {
                <!-- Default to radio buttons if supportsOtherValue() true and passes other conditions -->
                <div
                  class="radio-group-container"
                  attr.aria-labelledby="{{ attribute.attributeDefinitionId }}"
                  [ngClass]="
                    attributesForm.get(attribute.attributeDefinitionId)
                      .touched &&
                    (attributesForm
                      .get(attribute.attributeDefinitionId)
                      .hasError('notEmpty') ||
                      attributesForm
                        .get(attribute.attributeDefinitionId)
                        .hasError('otherRequired'))
                      ? 'radio-error'
                      : ''
                  "
                >
                  @if (attribute.required) {
                    <div class="radio-required-text">Required</div>
                  }
                  <mat-radio-group
                    [formControlName]="attribute.attributeDefinitionId"
                    role="radiogroup"
                    attr.aria-labelledby="{{ attribute.attributeDefinitionId }}"
                    [attr.aria-describedby]="attribute.attributeDefinitionId"
                    (change)="
                      assignValueToAttribute(attribute);
                      onDropdownChange($event, attribute);
                      onFieldChanged(attribute.attributeDefinitionId)
                    "
                  >
                    @for (
                      valueListItem of getAttributeValueList(attribute);
                      track valueListItem
                    ) {
                      <mat-radio-button
                        class="radio-item"
                        color="primary"
                        [value]="valueListItem"
                        [disabled]="attribute.isReadOnly"
                      >
                        {{ valueListItem.itemValue }}
                      </mat-radio-button>
                    }
                  </mat-radio-group>
                  @if (
                    !attribute.required &&
                    attributesForm.get(attribute.attributeDefinitionId).value
                  ) {
                    <button
                      type="button"
                      mat-button
                      color="primary"
                      class="radio-clear-button"
                      (click)="clearRadioButtonGroup(attribute)"
                    >
                      Clear selection
                    </button>
                  }
                  @if (
                    attributesForm.get(attribute.attributeDefinitionId)
                      .touched &&
                    attributesForm
                      .get(attribute.attributeDefinitionId)
                      .hasError('notEmpty')
                  ) {
                    <mat-error class="radio-error-message">
                      {{
                        attributesForm
                          .get(attribute.attributeDefinitionId)
                          .getError('notEmpty')
                      }}
                    </mat-error>
                  }
                </div>
              }
              @if (this.isOtherTextShown(attribute)) {
                <mat-form-field appearance="outline">
                  <input
                    matInput
                    placeholder="Please specify"
                    [formControlName]="otherInputControlName(attribute)"
                  />
                  @if (
                    attributesForm
                      .get(attribute.attributeDefinitionId)
                      ?.hasError('otherRequired')
                  ) {
                    <mat-error>
                      {{
                        attributesForm
                          .get(attribute.attributeDefinitionId)
                          ?.getError('otherRequired')
                      }}
                    </mat-error>
                  }
                </mat-form-field>
              }
            } @else if (attribute.type === shortAnswerAttributeUiType) {
              <mat-form-field
                appearance="outline"
                floatLabel="always"
                [fxFlex]="fxFlexWidth"
                class="short-answer-field"
              >
                <input
                  matInput
                  forbidAngleBrackets
                  type="text"
                  formControlName="{{ attribute.attributeDefinitionId }}"
                  placeholder="{{ attribute.required ? 'Required' : '' }}"
                  (blur)="assignValueToAttribute(attribute)"
                  attr.aria-labelledby="{{ attribute.attributeDefinitionId }}"
                  (change)="onFieldChanged(attribute.attributeDefinitionId)"
                />
                @if (
                  attributesForm
                    .get(attribute.attributeDefinitionId)
                    .hasError('notEmpty')
                ) {
                  <mat-error>
                    {{
                      attributesForm
                        .get(attribute.attributeDefinitionId)
                        .getError('notEmpty')
                    }}
                  </mat-error>
                }
              </mat-form-field>
            } @else if (attribute.type === longAnswerAttributeUiType) {
              <rich-text-editor
                [form]="attributesForm"
                [field]="attribute.attributeDefinitionId"
                [fieldName]="attribute.name"
                [placeholder]="attribute.required ? 'Required' : ''"
                (textChanged)="
                  longAnswerChanged(attribute, $event);
                  onFieldChanged(attribute.attributeDefinitionId)
                "
              ></rich-text-editor>
            } @else if (attribute.type === starRatingAttributeUiType) {
              <app-star-rating-attribute
                [editMode]="true"
                [starRatings]="getAttributeValueList(attribute)"
                [selectedStarRating]="
                  attribute.attributeDefinitionValueListItem
                "
                (selectedChanged)="
                  skillChanged(attribute, $event);
                  onFieldChanged(attribute.attributeDefinitionId)
                "
              ></app-star-rating-attribute>
            } @else if (attribute.type === skillAttributeUiType) {
              <skill
                [required]="attribute.required"
                [isTouched]="isAttributeTouched(attribute)"
                [editMode]="true"
                [skillLevels]="getAttributeValueList(attribute)"
                [selectedSkillLevel]="
                  attribute.attributeDefinitionValueListItem
                "
                [errorMessage]="attribute.name + ' is required'"
                (selectedChanged)="skillChanged(attribute, $event)"
                (change)="onFieldChanged(attribute.attributeDefinitionId)"
                [ariaLabelledby]="attribute.attributeDefinitionId"
                [title]="
                  useAttributeDescription
                    ? attribute.description
                    : attribute.name
                "
              ></skill>
            } @else if (attribute.type === numberAttributeUiType) {
              <mat-form-field
                appearance="outline"
                floatLabel="always"
                class="number-field"
              >
                <input
                  matInput
                  type="number"
                  min="{{
                    getAttributeDefinitionById(attribute.attributeDefinitionId)
                      .min
                  }}"
                  max="{{
                    getAttributeDefinitionById(attribute.attributeDefinitionId)
                      .max
                  }}"
                  formControlName="{{ attribute.attributeDefinitionId }}"
                  placeholder="{{ attribute.required ? 'Required' : '' }}"
                  (blur)="assignValueToAttribute(attribute)"
                  attr.aria-labelledby="{{ attribute.attributeDefinitionId }}"
                  (change)="onFieldChanged(attribute.attributeDefinitionId)"
                />
                @if (
                  attributesForm
                    .get(attribute.attributeDefinitionId)
                    .hasError('numberRange')
                ) {
                  <mat-error>
                    {{
                      attributesForm
                        .get(attribute.attributeDefinitionId)
                        .getError('numberRange')
                    }}
                  </mat-error>
                }
                @if (
                  attributesForm
                    .get(attribute.attributeDefinitionId)
                    .hasError('notEmpty')
                ) {
                  <mat-error>
                    {{
                      attributesForm
                        .get(attribute.attributeDefinitionId)
                        .getError('notEmpty')
                    }}
                  </mat-error>
                }
              </mat-form-field>
            } @else if (attribute.type === dateAttributeUiType) {
              <mat-form-field
                appearance="outline"
                floatLabel="always"
                class="date-field"
              >
                <input
                  matInput
                  [matDatepicker]="picker"
                  [formControlName]="attribute.attributeDefinitionId"
                  [placeholder]="attribute.required ? 'Required' : ''"
                  (dateChange)="
                    assignValueToAttribute(attribute);
                    onFieldChanged(attribute.attributeDefinitionId)
                  "
                  attr.aria-labelledby="{{ attribute.attributeDefinitionId }}"
                />
                <mat-datepicker-toggle
                  matSuffix
                  [for]="picker"
                  [aria-label]="
                    'Open calendar for ' +
                    (useAttributeDescription
                      ? attribute.description
                      : attribute.name)
                  "
                ></mat-datepicker-toggle>
                <mat-datepicker #picker></mat-datepicker>
                @if (
                  attributesForm
                    .get(attribute.attributeDefinitionId)
                    .hasError('invaliddate')
                ) {
                  <mat-error>
                    {{ attribute.name }} must be a valid date in mm/dd/yyyy
                    format.
                  </mat-error>
                }
                @if (
                  attributesForm
                    .get(attribute.attributeDefinitionId)
                    .hasError('notEmpty') &&
                  !attributesForm
                    .get(attribute.attributeDefinitionId)
                    .hasError('matDatepickerParse')
                ) {
                  <mat-error>
                    {{
                      attributesForm
                        .get(attribute.attributeDefinitionId)
                        .getError('notEmpty')
                    }}
                  </mat-error>
                }
              </mat-form-field>
            } @else if (attribute.type === documentUiType) {
              <app-custom-document-uploader
                [mode]="mode"
                [uploadPath]="getUploadPath(attribute)"
                (uploadedFilesChanged)="
                  customDocumentUploaderChanged(attribute, $event);
                  onFieldChanged(attribute.attributeDefinitionId)
                "
                (uploadStatusChanged)="isUploading = $event"
                [errorMessage]="attribute.name + ' is required'"
                [required]="attribute.required"
                [isTouched]="isAttributeTouched(attribute)"
                [previouslyUploadedFiles]="attribute.value"
                [entityId]="entityId"
                (downLoadFile)="onDownloadFile($event, attribute)"
              ></app-custom-document-uploader>
            } @else if (attribute.type === complexUiType) {
              <div fxLayout="column">
                <button
                  [disabled]="attributeComplex(attribute)"
                  fxFlex="100"
                  mat-stroked-button
                  color="primary"
                  class="add-complex-button"
                  (click)="onAddComplexValue(attribute)"
                >
                  <mat-icon>add</mat-icon> Add New {{ attribute.name }}
                </button>
                @for (
                  complexAttributeValue of attribute.complexAttributeValues;
                  track complexAttributeValue
                ) {
                  <div
                    class="editable-complex-value"
                    [ngClass]="{
                      'complex-error-border': !isComplexAttributeValueValid(
                        attribute,
                        complexAttributeValue
                      )
                    }"
                  >
                    <div class="complex-buttons">
                      <button
                        (click)="
                          onEditComplexValue(attribute, complexAttributeValue)
                        "
                        mat-icon-button
                        [attr.aria-label]="
                          'Edit ' +
                          (complexAttributeValue.items[0]?.value || '') +
                          ' entry'
                        "
                      >
                        <mat-icon>edit</mat-icon>
                      </button>
                      <button
                        mat-icon-button
                        (click)="
                          onDeleteComplexValue(attribute, complexAttributeValue)
                        "
                        [attr.aria-label]="
                          'Delete ' +
                          (complexAttributeValue.items[0]?.value || '') +
                          ' entry'
                        "
                      >
                        <mat-icon>delete</mat-icon>
                      </button>
                    </div>
                    <app-complex-field-viewer
                      [complexAttributeValue]="complexAttributeValue"
                    ></app-complex-field-viewer>
                  </div>
                }
                @if (
                  attributesForm
                    .get(attribute.attributeDefinitionId)
                    .hasError('complexRange')
                ) {
                  <mat-error class="complex-error">
                    {{
                      attributesForm
                        .get(attribute.attributeDefinitionId)
                        .getError('complexRange')
                    }}
                  </mat-error>
                }
                @if (
                  attributesForm
                    .get(attribute.attributeDefinitionId)
                    .hasError('complexSubFieldRequired')
                ) {
                  <mat-error class="complex-error">
                    {{
                      attributesForm
                        .get(attribute.attributeDefinitionId)
                        .getError('complexSubFieldRequired')
                    }}
                  </mat-error>
                }
              </div>
            } @else if (attribute.type === dateRangeUiType) {
              <daterange
                [isTouched]="isAttributeTouched(attribute)"
                [fieldValue]="attribute.value"
                [required]="attribute.required"
                [placeholder]="attribute.required ? 'Required' : ''"
                [errorMessage]="attribute.name + ' is required'"
                [fieldName]="
                  useAttributeDescription
                    ? attribute.description
                    : attribute.name
                "
                (dateChanged)="
                  dateRangeChanged(attribute, $event);
                  onFieldChanged(attribute.attributeDefinitionId)
                "
              ></daterange>
            } @else if (attribute.type === encryptedFieldAttributeUiType) {
              <mat-form-field
                appearance="outline"
                floatLabel="always"
                [fxFlex]="fxFlexWidth"
                class="short-answer-field"
              >
                <div fxLayout="row">
                  <input
                    matInput
                    forbidAngleBrackets
                    type="text"
                    formControlName="{{ attribute.attributeDefinitionId }}"
                    placeholder="{{ attribute.required ? 'Required' : '' }}"
                    (blur)="assignValueToAttribute(attribute)"
                    attr.aria-labelledby="{{ attribute.attributeDefinitionId }}"
                    (change)="
                      onFieldChanged('{{ attribute.attributeDefinitionId }}')
                    "
                  />
                  @if (
                    attribute.value &&
                    !attributesForm.get(attribute.attributeDefinitionId)
                      .dirty &&
                    (attribute.value | base64UrlEncoded) &&
                    (isProfileEditorMode() ||
                      (isPrivate && attribute.showCurrentValue))
                  ) {
                    <button
                      appThrottleClick
                      mat-icon-button
                      [matTooltip]="
                        isRevealed(attribute) ? 'Hide value' : 'Show value'
                      "
                      matTooltipPosition="before"
                      (click)="togglePasswordVisibility(attribute)"
                    >
                      <mat-icon
                        class="edit-icon mat-icon material-icons md-18"
                        >{{
                          isRevealed(attribute)
                            ? 'visibility_off'
                            : 'visibility'
                        }}</mat-icon
                      >
                    </button>
                  }
                  @if (
                    attributesForm
                      .get(attribute.attributeDefinitionId)
                      .hasError('notEmpty')
                  ) {
                    <mat-error>
                      {{
                        attributesForm
                          .get(attribute.attributeDefinitionId)
                          .getError('notEmpty')
                      }}
                    </mat-error>
                  }
                </div>
              </mat-form-field>
            }
          } @else {
            <!-- is readonly true and has a value-->
            <app-field-label
              [props]="attribute"
              [readonly]="true"
              [useAttributeDescription]="useAttributeDescription"
            >
            </app-field-label>
            @if (attribute.type === skillAttributeUiType) {
              <skill
                [editMode]="false"
                [skillLevels]="getAttributeValueList(attribute)"
                [selectedSkillLevel]="
                  attribute.attributeDefinitionValueListItem
                "
                [ariaLabelledby]="attribute.attributeDefinitionId"
                [title]="
                  useAttributeDescription
                    ? attribute.description
                    : attribute.name
                "
              ></skill>
            } @else if (attribute.type === starRatingAttributeUiType) {
              <app-star-rating-attribute
                [editMode]="false"
                [starRatings]="getAttributeValueList(attribute)"
                [selectedStarRating]="
                  attribute.attributeDefinitionValueListItem
                "
              ></app-star-rating-attribute>
            } @else if (attribute.type === documentUiType) {
              <app-custom-document-uploader
                [readOnly]="attribute.isReadOnly"
                [mode]="mode"
                (downLoadFile)="onDownloadFile($event, attribute)"
                [previouslyUploadedFiles]="attribute.value"
                [entityId]="entityId"
              ></app-custom-document-uploader>
            } @else if (attribute.type === complexUiType) {
              @for (
                complexAttributeValue of attribute.complexAttributeValues;
                track complexAttributeValue
              ) {
                <div class="editable-complex-value">
                  <app-complex-field-viewer
                    [complexAttributeValue]="complexAttributeValue"
                  ></app-complex-field-viewer>
                </div>
              }
            } @else if (attribute.type === encryptedFieldAttributeUiType) {
              <div class="readonly-encrypted-container">
                <p class="readonly-value">
                  {{
                    attributesForm.get(attribute.attributeDefinitionId).value
                  }}
                </p>
                @if (
                  (attribute.value | base64UrlEncoded) &&
                  (isProfileEditorMode() ||
                    (isPrivate && attribute.showCurrentValue))
                ) {
                  <button
                    appThrottleClick
                    mat-icon-button
                    [matTooltip]="
                      isRevealed(attribute) ? 'Hide value' : 'Show value'
                    "
                    matTooltipPosition="before"
                    (click)="togglePasswordVisibility(attribute)"
                  >
                    <mat-icon class="edit-icon mat-icon material-icons md-18">{{
                      isRevealed(attribute) ? 'visibility_off' : 'visibility'
                    }}</mat-icon>
                  </button>
                }
              </div>
            } @else {
              @for (value of attribute.valueList; track value.id) {
                @if (value.isOther) {
                  <p class="readonly-value">
                    {{ attribute.otherValue }} ({{ value.itemValue }})
                  </p>
                } @else {
                  <p
                    class="readonly-value"
                    [innerHTML]="value.itemValue | safeHtml"
                  ></p>
                }
              }
              @if (attribute.value) {
                @if (attribute.otherValue) {
                  <p class="readonly-value">
                    {{ attribute.otherValue }} ({{ attribute.value }})
                  </p>
                } @else {
                  <p
                    class="readonly-value"
                    [innerHTML]="attribute.value | safeHtml"
                  ></p>
                }
              }
            }
          }
        </div>
      }
    }
  </form>
}
